import React, { useMemo } from 'react';
import { t } from 'i18next';
import {ArrowIcon} from '../../icons';
import SubOption from './sub-option';

const CollapsibleFilterOption = ({ 
    option, 
    isExpanded, 
    selectedFilters, 
    onToggleExpansion = () => {}, 
    onToggleSubOption = () => {}
}) => {
    const selectedSubOptionsCount = useMemo(() => {
        let count =0
        option?.options?.forEach((subOption) => {
            if(selectedFilters?.includes(subOption?.value)){
                count++;
            }
        });
        return count;
    }, [selectedFilters, option?.options]);
    return (
        <li className="flex flex-col gap-2 py-2 shadow-sm">
            <div 
                className="flex items-center gap-2 cursor-pointer" 
                onClick={onToggleExpansion}
            >
                {/* <span className="w-6 h-6 inline-flex">
                    <UNCHECKED />
                </span> */}
                <span className="font-semibold text-gray-700 flex-1 text-16x">
                    {option?.symbol} {t(option?.name, {count: selectedSubOptionsCount})} 
                </span>
                <ArrowIcon isExpanded={isExpanded} />
            </div>
            {isExpanded && (
                <ul className="ml-6 flex flex-col gap-1">
                    {option?.options?.map((subOption) => {
                        const isSubSelected = selectedFilters?.includes(subOption?.value);
                        return (
                            <SubOption
                                key={"sub-option-"+subOption?.value}
                                subOption={subOption}
                                isSelected={isSubSelected}
                                onToggle={() => onToggleSubOption(subOption?.value, isSubSelected)}
                            />
                        );
                    })}
                </ul>
            )}
        </li>
    );
};

export default CollapsibleFilterOption;
